module.exports = __webpack_public_path__ + "img/value-2.15150606.svg";